export class Deferred {
  public resolve: Function;
  public reject: Function;
  public promise: Promise<any>;

  constructor() {
    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }
}
